import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminAPI } from '../../services/apiService';
import './AdminLogin.css';

export default function AdminLogin() {
    const navigate = useNavigate();

    const [form, setForm] = useState({
        username: '',
        password: '',
        requested_user: '',
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        setForm((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setError('');
        setLoading(true);

        try {
            const res = await AdminAPI.loginAsUser(form);

            const token = res.access;
            const refToken = res.refresh;

            if (!token) {
                throw new Error('JWT token was not returned.');
            }

            localStorage.setItem('token', token);
            localStorage.setItem('refreshToken', refToken);

            navigate('/');
        } catch (err) {
            setError(err.message || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-page">
            <form className="admin-login-card" onSubmit={handleSubmit}>
                <h2>Admin Login</h2>

                {error && <div className="admin-login-error">{error}</div>}

                <input
                    name="username"
                    type="text"
                    placeholder="Admin Username"
                    value={form.username}
                    onChange={handleChange}
                    autoComplete="username"
                />

                <input
                    name="password"
                    type="password"
                    placeholder="Admin Password"
                    value={form.password}
                    onChange={handleChange}
                    autoComplete="current-password"
                />

                <input
                    name="requested_user"
                    type="text"
                    placeholder="Requested User"
                    value={form.requested_user}
                    onChange={handleChange}
                />

                <button type="submit" disabled={loading}>
                    {loading ? 'Logging in...' : 'Login'}
                </button>

                <button type="button" className="back-button" onClick={() => navigate(-1)}>
                    Back
                </button>
            </form>
        </div>
    );
}
